export enum enumDependantEntityType {
  ISF,
  ENTRY_SUMMARY,
  COMPANY,
}
